/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPatchedUserPreferencesRequestLanguage } from './APIPatchedUserPreferencesRequestLanguage';
import {
    APIPatchedUserPreferencesRequestLanguageFromJSON,
    APIPatchedUserPreferencesRequestLanguageFromJSONTyped,
    APIPatchedUserPreferencesRequestLanguageToJSON,
} from './APIPatchedUserPreferencesRequestLanguage';

/**
 * 
 * @export
 * @interface APIPatchedUserPreferencesRequest
 */
export interface APIPatchedUserPreferencesRequest {
    /**
     * 
     * @type {APIPatchedUserPreferencesRequestLanguage}
     * @memberof APIPatchedUserPreferencesRequest
     */
    language?: APIPatchedUserPreferencesRequestLanguage;
}

/**
 * Check if a given object implements the APIPatchedUserPreferencesRequest interface.
 */
export function instanceOfAPIPatchedUserPreferencesRequest(value: object): value is APIPatchedUserPreferencesRequest {
    return true;
}

export function APIPatchedUserPreferencesRequestFromJSON(json: any): APIPatchedUserPreferencesRequest {
    return APIPatchedUserPreferencesRequestFromJSONTyped(json, false);
}

export function APIPatchedUserPreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedUserPreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : APIPatchedUserPreferencesRequestLanguageFromJSON(json['language']),
    };
}

export function APIPatchedUserPreferencesRequestToJSON(value?: APIPatchedUserPreferencesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': APIPatchedUserPreferencesRequestLanguageToJSON(value['language']),
    };
}

